package com.xtream.data_kmp.db

import androidx.room3.ColumnTypeConverters
import androidx.room3.ConstructedBy
import androidx.room3.DaoReturnTypeConverters
import androidx.room3.Database
import androidx.room3.RoomDatabase
import androidx.room3.RoomDatabaseConstructor
import androidx.room3.paging.PagingSourceDaoReturnTypeConverter
import com.xtream.data_kmp.FavoriteLiveStreamEntity
import com.xtream.data_kmp.FavoriteSeriesStreamEntity
import com.xtream.data_kmp.FavoriteVodStreamEntity
import com.xtream.data_kmp.WatchedLiveStreams
import com.xtream.data_kmp.WatchedSeriesStreams
import com.xtream.data_kmp.WatchedVodStreams
import com.xtream.data_kmp.db.dao.HiddenCategoryDao
import com.xtream.data_kmp.db.dao.LiveCategoriesDao
import com.xtream.data_kmp.db.dao.LiveFavDao
import com.xtream.data_kmp.db.dao.LiveStreamOrderDao
import com.xtream.data_kmp.db.dao.LiveStreamsDao
import com.xtream.data_kmp.db.dao.SeriesCategoriesDao
import com.xtream.data_kmp.db.dao.SeriesFavDao
import com.xtream.data_kmp.db.dao.SeriesStreamsDao
import com.xtream.data_kmp.db.dao.UserDao
import com.xtream.data_kmp.db.dao.VodCategoriesDao
import com.xtream.data_kmp.db.dao.VodStreamsDao
import com.xtream.data_kmp.db.dao.VodsFavDao
import com.xtream.data_kmp.db.dao.WatchedLiveDao
import com.xtream.data_kmp.db.dao.WatchedSeriesDao
import com.xtream.data_kmp.db.dao.WatchedVodDao
import com.xtream.data_kmp.db.tables.HiddenCategoryEntity
import com.xtream.data_kmp.db.tables.LiveStreamOrderEntity
import com.xtream.data_kmp.dto.Account
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.TrendingMovie
import com.xtream.data_kmp.dto.TrendingTvShow
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodStream

@Suppress("NO_ACTUAL_FOR_EXPECT", "EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING") // Room KSP will generate the actual implementation
expect object AppRoomDBConstructor : RoomDatabaseConstructor<AppRoomDB>
@Database(entities = [
    //user table
    Account::class,
    //streams tables
    LiveStream::class, VodStream::class, SeriesStream::class,
    //categories tables
    LiveCategory::class, VodCategory::class, SeriesCategory::class,

    //fav categories tables
    FavoriteLiveStreamEntity::class, FavoriteVodStreamEntity::class, FavoriteSeriesStreamEntity::class,
    //watched tables
    WatchedLiveStreams::class, WatchedVodStreams::class, WatchedSeriesStreams::class,
TrendingMovie::class, TrendingTvShow::class,

    LiveStreamOrderEntity::class,
    HiddenCategoryEntity::class


                     ],

/*autoMigrations = [
    AutoMigration(from = 26, to = 27),
    AutoMigration(from = 27, to = 28,spec = AutoMigrateWatchedLiveStreams::class),

],*/
    exportSchema = true, version = 40)
@ColumnTypeConverters(StringListConverter::class, StreamTypeConverter::class)
@DaoReturnTypeConverters(PagingSourceDaoReturnTypeConverter::class) // add this
@ConstructedBy( AppRoomDBConstructor::class)
abstract class AppRoomDB : RoomDatabase() {
    //streams
    abstract fun userDao(): UserDao
    abstract fun liveStreamsDao(): LiveStreamsDao
    abstract fun vodDao(): VodStreamsDao
    abstract fun seriesDao(): SeriesStreamsDao

    //categories
    abstract fun liveCategoriesDao(): LiveCategoriesDao
    abstract fun vodCategoriesDao(): VodCategoriesDao
    abstract fun seriesCategoriesDao(): SeriesCategoriesDao

    //favorites
    abstract fun liveFavoritesDao(): LiveFavDao
    abstract fun vodFavoritesDao(): VodsFavDao
    abstract fun seriesFavoritesDao(): SeriesFavDao

    abstract fun watchedLiveDao(): WatchedLiveDao
    abstract fun watchedVodDao(): WatchedVodDao
    abstract fun watchedSeriesDao(): WatchedSeriesDao
    abstract fun liveStreamOrderDao(): LiveStreamOrderDao
    abstract fun hiddenCategoryDao(): HiddenCategoryDao



}